export default {
  // 页面标题
  title: '预警设置',
  // 预警监控规则
  sectionAlertRule: '预警监控规则',
  alertEnabled: '功能开关',
  alertEnabledDesc: '开启后，当某个二维码达到设定的扫码次数后，系统将自动触发预警。',
  scanCountThreshold: '预警扫码次数阈值',
  scanCountThresholdUnit: '次',
  scanCountThresholdDesc: '设置触发预警的扫码次数，当二维码被扫描次数达到此数值时触发预警。',
  // 自动化处置策略
  sectionAutoDispose: '自动化处置策略',
  autoDisposeEnabled: '功能开关',
  autoDisposeEnabledDesc: '开启后，当二维码触发预警时，系统将自动禁用二维码，阻止继续被扫描。',
  triggerCondition: '触发条件',
  triggerOnScanCount: '触发扫码次数预警时',
  executeAction: '执行禁用操作',
  disableScopeSingle: '禁用预警的二维码',
  disableScopeBatch: '禁用同批次所有二维码',
  disableTip: '禁用提示语（消费者端文案）',
  disableTipDesc: '设置当消费者扫描被禁用的二维码时，手机端显示的提示内容。',
  disableTipPlaceholder: '请输入禁用提示语',
  // 保存
  save: '保存',
  saveSuccess: '保存成功',
};
